import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addDischargeArrayItem,
  removeDischargeArrayItem,
} from "../../../../Redux/actions/dischargeActions";
import { FiTrash2, FiPlus } from "react-icons/fi";
import DrugServices from "../../../../Services/DrugServices";

export default function MedicationOnDischarge() {
  const dispatch = useDispatch();
  const dischargeMedication = useSelector(
    (state) => state.discharge?.dischargeMedication || []
  );

  let loginData = sessionStorage.getItem("login_result");
  let loginDataObject = loginData ? JSON.parse(loginData) : null;

  const [formData, setFormData] = useState({
    drugName: "",
    strength: "",
    dosage: "",
    frequency: "",
    duration: "",
    instruction: "",
  });

  const [medicineList, setMedicineList] = useState([]);
  const [selectedMed, setSelectedMed] = useState({});

  const handleFormChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const onSearchMedicine = async (value) => {
    if (value.length < 2) {
      setMedicineList([]);
      return;
    }
    let payload = {
      medicineName: value,
      pageNo: 1,
      size: 40,
      userId: loginDataObject?.user?.userId,
    };
    if (loginDataObject?.user?.userId === "DZU3191271") {
      payload.pharmacyId = "DZA1361124";
    }
    try {
      let result = await DrugServices.fetchElasticDrugListnew(payload);
      setMedicineList(result?.data?.data || []);
    } catch (error) {
      console.error(error);
    }
  };

  const handleSelectMedicine = (medicine) => {
    setSelectedMed(medicine);
    setMedicineList([]);
    setFormData((prev) => ({
      ...prev,
      drugName: medicine.medicineName,
      strength: medicine.saltComposition || prev.strength,
    }));
  };

  const handleAddMedication = () => {
    if (!formData.drugName) return;

    dispatch(
      addDischargeArrayItem("dischargeMedication", {
        medicationId: null,
        drugId: selectedMed?.code || `DRG00${dischargeMedication.length + 1}`,
        drugName: formData.drugName,
        strength: formData.strength,
        dosage: formData.dosage || "1 Tablet",
        frequency: formData.frequency || "1-0-1",
        duration: formData.duration || "5 Days",
        route: "Oral",
        instruction: formData.instruction || "Take after food with water.",
        startDate: new Date().toISOString().substring(0, 10),
        endDate: new Date(Date.now() + 5 * 24 * 60 * 60 * 1000).toISOString().substring(0, 10),
        displayOrder: dischargeMedication.length + 1,
        activeYn: "Y",
        status: 1,
      })
    );

    setFormData({
      drugName: "",
      strength: "",
      dosage: "",
      frequency: "",
      duration: "",
      instruction: "",
    });
    setSelectedMed({});
    setMedicineList([]);
  };

  const handleRemoveMedication = (index) => {
    dispatch(removeDischargeArrayItem("dischargeMedication", index));
  };

  return (
    <div className="bg-white rounded-lg border border-gray-100 p-4 shadow-sm hover:shadow-md transition-shadow">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
        <h3 className="text-sm font-bold text-teal-700 flex items-center gap-2">
          <span className="w-2 h-2 rounded-full bg-teal-600"></span>
          7. Medication on Discharge ({dischargeMedication.length})
        </h3>
      </div>

      <div className="bg-gray-50 border border-gray-200 rounded-lg p-3 mb-4 flex gap-2 items-center flex-wrap">
        {/* Medicine Name with live search dropdown */}
        <div className="relative flex-1 min-w-[160px]">
          <input
            value={formData.drugName}
            onChange={(e) => {
              handleFormChange("drugName", e.target.value);
              onSearchMedicine(e.target.value);
            }}
            placeholder="Medicine Name"
            className="w-full border border-gray-200 rounded px-2 py-1.5 outline-none focus:border-teal-500 bg-white text-xs font-semibold"
          />
          {medicineList.length > 0 && (
            <ul className="absolute top-8 left-0 w-full mt-1 bg-white border rounded-md shadow-md max-h-40 overflow-y-auto z-10">
              {medicineList.map((medicine, idx) => (
                <li
                  key={medicine.id || idx}
                  onClick={() => handleSelectMedicine(medicine)}
                  className="px-2 py-1.5 text-xs font-sans hover:bg-gray-200 cursor-pointer border-b last:border-b-0 text-gray-700"
                >
                  {medicine.medicineName}
                </li>
              ))}
            </ul>
          )}
        </div>

        <input
          type="text"
          value={formData.strength}
          onChange={(e) => handleFormChange("strength", e.target.value)}
          placeholder="Strength"
          className="w-20 border border-gray-200 rounded px-2 py-1.5 outline-none focus:border-teal-500 bg-white text-xs"
        />
        <input
          type="text"
          value={formData.dosage}
          onChange={(e) => handleFormChange("dosage", e.target.value)}
          placeholder="Dosage"
          className="w-20 border border-gray-200 rounded px-2 py-1.5 outline-none focus:border-teal-500 bg-white text-xs"
        />
        <input
          type="text"
          value={formData.frequency}
          onChange={(e) => handleFormChange("frequency", e.target.value)}
          placeholder="Frequency"
          className="w-20 border border-gray-200 rounded px-2 py-1.5 outline-none focus:border-teal-500 bg-white text-xs"
        />
        <input
          type="text"
          value={formData.duration}
          onChange={(e) => handleFormChange("duration", e.target.value)}
          placeholder="Duration"
          className="w-20 border border-gray-200 rounded px-2 py-1.5 outline-none focus:border-teal-500 bg-white text-xs"
        />
        <input
          type="text"
          value={formData.instruction}
          onChange={(e) => handleFormChange("instruction", e.target.value)}
          placeholder="Instructions"
          className="flex-1 min-w-[120px] border border-gray-200 rounded px-2 py-1.5 outline-none focus:border-teal-500 bg-white text-xs"
        />

        <button
          type="button"
          onClick={handleAddMedication}
          className="flex items-center text-white cursor-pointer gap-1.5 bg-teal-700 text-xs font-semibold px-3 py-1.5 rounded-md hover:bg-teal-800 shadow-sm transition"
        >
          <FiPlus className="text-[13px]" /> Add
        </button>
      </div>

      <div className="border border-gray-200 rounded-lg overflow-x-auto">
        <table className="w-full text-left text-xs min-w-[620px]">
          <thead className="bg-gray-50 text-gray-600 font-semibold border-b border-gray-200">
            <tr>
              <th className="px-2.5 py-2">Medicine</th>
              <th className="px-2.5 py-2">Strength</th>
              <th className="px-2.5 py-2">Dosage</th>
              <th className="px-2.5 py-2">Frequency</th>
              <th className="px-2.5 py-2">Duration</th>
              <th className="px-2.5 py-2">Instruction</th>
              <th className="px-2 py-2 text-center">Action</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100 font-medium text-gray-700">
            {dischargeMedication.map((item, index) => (
              <tr key={index} className="hover:bg-gray-50/70 transition">
                <td className="px-2.5 py-2">{item.drugName}</td>
                <td className="px-2.5 py-2">{item.strength}</td>
                <td className="px-2.5 py-2">{item.dosage}</td>
                <td className="px-2.5 py-2">{item.frequency}</td>
                <td className="px-2.5 py-2">{item.duration}</td>
                <td className="px-2.5 py-2">{item.instruction}</td>
                <td className="px-2 py-2 text-center">
                  <button
                    type="button"
                    onClick={() => handleRemoveMedication(index)}
                    className="text-red-500 bg-white hover:text-red-700 p-1 hover:bg-red-50 rounded transition"
                    title="Remove medication"
                  >
                    <FiTrash2 className="text-xs" />
                  </button>
                </td>
              </tr>
            ))}
            {dischargeMedication.length === 0 && (
              <tr>
                <td colSpan="7" className="px-2.5 py-4 text-center text-gray-400">
                  No medications added yet.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

